import { render, staticRenderFns } from "./global-elements.vue?vue&type=template&id=582317d7&scoped=true&"
import script from "./global-elements.vue?vue&type=script&lang=js&"
export * from "./global-elements.vue?vue&type=script&lang=js&"
import style0 from "./global-elements.vue?vue&type=style&index=0&id=582317d7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582317d7",
  null
  
)

component.options.__file = "global-elements.vue"
export default component.exports